<template>
  <div class="container mod-order-pay">
    <div v-if="shoppingCart" class="fetch-loading-container">
      <a-spin></a-spin>
    </div>
    <template v-else>
      <template v-if="submitResult.success">
          <div class="pay-head clearfix">
          <!-- <span class="f-26 f-left">恭喜您，订单生成成功！</span> -->
          <span class="f-18 order-num">
            订单号：
            <a @click="hrefOrderHandler">{{ orderNo }}</a>
          </span>
        </div>
        <p class="tips">
          <template v-if="payLimit">
            <em class="f-16">友情提醒：</em>请在支付前再次确认您的出行信息，订单信息无误后进行操作。您需要在
            <em class="f-16">{{ payLimit | payLimit }}</em>内完成订单支付，超过支付时限未完成支付，航空公司将不保证您的订单有效。
          </template>
          <template v-else>
            <em class="f-16">友情提醒：</em>已超过订单支付时限，请勿再操作支付，避免无法出票产生损失。
          </template>
        </p>
      </template>
      <template v-else>
        <div class="submit-error">
          <span class="f-26">
            抱歉，订单生成失败，请点击
            <router-link to="/flight/search">返回</router-link> 重新查询下单。
          </span>
        </div>
      </template>
      <template v-if="submitResult.success">
        <div class="pay-passengers m-t-50">
          <l8-passenger-seg-list
            :passengers="detail.travelers"
            :order="{bookTime: detail.createTime}"
            :select-able="false"
            :edit-able="false"
            :exs-action="false"
          ></l8-passenger-seg-list>
        </div>
        <div class="pay-itinerary" v-if="detail.itinerary">
          <table class="pay-itinerary-table">
            <tbody>
              <tr>
                <td class="_b">行程单</td>
                <td class="_r">{{ detail.itinerary.amount || '--' }}元</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pay-box-outer m-t-50">
          <div class="pay-head clearfix">
            <span class="f-26">确认支付</span>
            <span class="f-16 price">
              订单总额：
              <em>{{ noPaidAmount }}元</em>
            </span>
            <span class="activity" v-if="hasActivity"></span>
          </div>
          <div class="pay-box">
            <pay-box
              v-if="detail.status === 'WP'"
              :paySymbol="{
                hasInsurance: extraField?.hasInsurance,
              }"
              :hnairPayFilter="hnairPayExtendFilter"
              :sellerChannel="sellerChannel"
              :owner="owner"
              ref="payBox"
              @tabChange="payTabChangeHandler"
              @paying="payingHandler"
              @paid="payDoneHandler"
            ></pay-box>
          </div>
          <div class="pay-foot">
            <a-button class="btn" type="primary" @click="toOrderHandler">查看订单</a-button>
            <a-button class="btn" type="primary" :disabled="detail.status !== 'WP'" @click="toPay" :loading="payLoading">支付</a-button>
          </div>
        </div>
      </template>
    </template>
    <a-modal
      title="系统提示"
      v-model="payNoticeVisible"
      :closable="false"
      class="mod-l8-alert-model"
      centered
    >
      <template slot="footer">
        <a-button key="error" type="primary" @click="handleError">支付遇到问题</a-button>
        <a-button key="submit" type="primary" @click="handleOk">已完成付款</a-button>
      </template>
      <h1>请您在新打开的网上银行页面上完成付款</h1>
      <p>请检查浏览器是否拦截弹窗</p>
      <p>付款完成前请不要关闭此窗口</p>
      <p>完成付款后请根据您的情况点击下面的按钮</p>
    </a-modal>
  </div>
</template>
<script>
import { get } from 'lodash'
// import detail from '@/mock/order'
import { queryDetailV2, submitOrder } from '@/apis/order'
import '@/components/l8-icon'
import moment from 'moment'
import PayBox from '@/components/pay-box-new'
import Storage from '@/assets/js/storage'
import queryString from 'query-string'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}
const airline = mainSettings.airline || ''

export default {
  data () {
    return {
      shoppingCart: {},
      submitResult: {},
      detail: {},
      orderId: '',
      orderNo: '',
      totalAmount: '',
      noPaidAmount: '',
      payLoading: false,
      payNoticeVisible: false,
      // 支付方式过滤
      payFilter: [],
      payHidden: undefined,
      payExtend: undefined,
      payActiveKey: '1',
      hasActivity: false,
      payLimit: undefined,
      extraField: null,
      ifInternational: false,
      isGroupStaff: false, // 海航员工标识
      hnairPayConfig: null,
      owner: airline,
      sellerChannel: 'C' + airline.toLocaleUpperCase()
      // yeepayActivityDate: null
    }
  },
  provide () {
    return {
      ifInternational: () => this.ifInternational,
      getOrderId: () => this.orderId
    }
  },
  async created () {
    window.__MICRO_ROOT__?.api?.track?.('reserve_orderpay_info')
    await this.init()
    await this.getCmsData()
    // const pageCmsData = (await mainSettings.cms?.getPageData()) ?? {}
    // this.yeepayActivityDate = _.get(pageCmsData, 'pay-yeepay-activity-date.activityDate')
  },
  computed: {
    isSelfAirline () {
      const { detail } = this
      return get(detail, 'travelers[0].flightSegments[0].airlineCode') === airline
    },
    isOneWay () {
      const { detail } = this
      return get(detail, 'travelers[0].flightSegments')?.length === 1
    },
    isOnlyTicket () {
      const { detail = {} } = this
      let ancillaryFlag = false
      let itineraryFlag = Boolean(get(detail, 'itinerary'))
      detail.travelers?.forEach(traveler => {
        traveler.flightSegments?.forEach(seg => {
          if (seg.ancillaries?.length > 0) ancillaryFlag = true
        })
      })
      return !ancillaryFlag && !itineraryFlag
    },
    isJJC () {
      const { detail } = this
      // 各航司的军警残产品代码
      const jjcCodeList = ['JJC', 'PJC1', 'JJCP', 'JJC1']
      const productCode = get(detail, 'travelers[0].flightSegments[0].productCode')
      return jjcCodeList.includes(productCode)
    },
    isUseCoupon () {
      const { detail } = this
      return Number(detail.couponAmount) > 0
    }
  },
  methods: {
    async init () {
      const query = queryString.parse(location.search)
      this.ifInternational = query.ifInternational === 'true'
      this.shoppingCart = Storage.getItem(`SHOPPINGCART_DATA`) ?? null
      // 购物车不为空，未生单
      if (!this.shoppingCart) {
        const submitResult = this.submitResult = Storage.getItem(`SUBMIT_RESULT`) || {}
        if (!submitResult.success) {
          this.$error({
            title: '温馨提示',
            content: submitResult.message,
            okText: '继续下单'
          })
        } else {
          if (submitResult.code === '100010001' && submitResult.message) {
            this.$error({
              title: '温馨提示',
              content: submitResult.message,
              okText: '继续下单'
            })
          }
          if (!this.ifInternational) {
            this.orderId = submitResult.data
          } else {
            this.orderNo = submitResult.data
          }
          await this.fetchOrder()
        }
      } else {
        // 完善从保险回调后的生单处理
        if (query.from === 'ehanglian') {
          try {
            let submitResult = await submitOrder({
              shoppingCartId: this.shoppingCart?.shoppingCartId,
              ifInternational: this.ifInternational
            })

            // TODO: 注意测试覆盖
            if (submitResult.code === '100010001' && submitResult.extraInfo && submitResult.extraInfo.data) {
              submitResult = {
                success: true,
                data: submitResult.extraInfo.data
              }
            } else {
              submitResult = {
                success: true,
                data: submitResult
              }
            }

            // 清理下单流程使用到的Storage
            Storage.removeItem(`SHOPPINGCART_DATA`)
            Storage.removeItem(`isJJC`)

            if (submitResult.success) {
              Storage.setItem(`SUBMIT_RESULT`, submitResult, 0.5 * 3600000)
              this.init()
            }
          } catch (error) {
            this.shoppingCart = null
            this.$message.error(error.message || '网络异常，请稍后再试！')
          }
        }
      }
    },
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          this.hnairPayConfig = get(res, 'hnair-pay-settings')
        })
      } catch (err) {}
    },
    toPay () {
      window.__MICRO_ROOT__?.api?.track?.('reserve_orderpay_pay')
      const { orderId, orderNo, noPaidAmount, ifInternational, sellerChannel } = this
      this.payLoading = true
      this.$refs['payBox'].doPay({
        orderId: orderId,
        orderNo: orderNo,
        amount: noPaidAmount,
        orderType: 'TICKET',
        returnUrl: '/micro/main/order/v2/payResult',
        extraCommonParam: !ifInternational ? `orderId:${orderId}~sellerChannel:${sellerChannel}` : `orderNo:${orderNo}~ifInternational:${ifInternational}~sellerChannel:${sellerChannel}`
      }).then(() => {
        this.payLoading = false
      }).catch(() => {
        this.payLoading = false
      })
    },
    async fetchOrder () {
      try {
        const { orderId, orderNo, ifInternational, sellerChannel } = this
        const params = {
          airline: mainSettings.airline,
          ifInternational,
          seller: mainSettings.airline,
          sellerChannel
        }
        if (!ifInternational) {
          params.orderId = orderId
        } else {
          params.orderNo = orderNo
        }
        const res = await queryDetailV2(params)
        this.ifInternational = res.ifInternational

        if (res.isCharterFlight) {
          this.payFilter = [{ bankId: 'YEEPAY' }]
          this.payActiveKey = '0'
        } else if (res.extraField) {
          this.extraField = JSON.parse(res.extraField)
          if (this.extraField.hasInsurance) {
            this.payFilter = [{ bankId: 'alipYE' }]
            this.payActiveKey = '0'
          }
        }

        if (airline === '8L') {
          const isAgent = [1, 2].includes(mainSettings.user?.get()?.userType)
          if (isAgent) {
            this.payHidden = [{
              title: '支付平台',
              items: [
                { id: 'CPAY' }
              ]
            }]
          }
          if (res.ifInternational) {
            this.payActiveKey = '0'
            this.payFilter = [{ bankId: 'alipYE' }]
          }
        }

        // 易宝活动显示活动图标
        // const { yeepayActivityDate } = this
        // if (yeepayActivityDate && yeepayActivityDate.length > 0) {
        //   this.yeepayLimitEvent(yeepayActivityDate)
        // }
        this.updateOrderDetail(res.offers[0].detail)
      } catch (err) {
        this.$message.error(err.message || '订单查询失败，请稍后再试')
      }
    },
    // yeepayLimitEvent (dateRange = []) {
    //   if (!Array.isArray(dateRange) || dateRange.length < 2) {
    //     return
    //   }
    //   const startTime = new Date(dateRange[0]).getTime()
    //   const endTime = new Date(dateRange[1]).getTime()
    //   const now = new Date().getTime()
    //   if (startTime <= now && now <= endTime) {
    //     this.payExtend = [
    //       {
    //         title: '支付平台',
    //         items: [
    //           {
    //             id: 'YEEPAY',
    //             class: 'manjian'
    //           }
    //         ]
    //       }
    //     ]
    //   }
    // },
    updateOrderDetail (detail) {
      this.detail = detail
      this.orderId = detail.orderId
      this.orderNo = detail.orderNo
      if (detail.owner) {
        this.owner = detail.owner
      }
      this.totalAmount = detail.totalAmount
      this.noPaidAmount = detail.noPaidAmount

      this.payLimit = detail.orderDuration

      if (detail.orderDuration > 0) {
        const interval = setInterval(() => {
          const d = this.payLimit - 1000

          if (d < 0) {
            clearInterval(interval)
          }

          this.payLimit = d > 0 ? d : 0
        }, 1000)
      }
    },
    // 查看订单
    toOrderHandler () {
      this.toOrder()
    },
    toOrder () {
      const { ifInternational, orderId, orderNo } = this
      const query = !ifInternational ? { orderId } : { orderNo, ifInternational }
      this.$router.replace({ path: '/order/v2/detail', query })
    },
    // 支付遇到问题
    handleError () {
      this.payNoticeVisible = false
    },
    // 已完成付款
    handleOk () {
      this.payNoticeVisible = false
      this.toOrder()
    },
    payTabChangeHandler (tab) {
    },
    payingHandler (bank) {
    },
    payDoneHandler (bank, status) {
      if (status === 'SUCCESS') {
        this.payNoticeVisible = true
      }
      this.payLoading = false
    },
    hrefOrderHandler () {
      this.toOrder()
    },
    // 海航通支付限制条件
    hnairPayExtendFilter () {
      const { detail, ifInternational, isSelfAirline, isOneWay, isOnlyTicket, isJJC, isUseCoupon } = this
      if (detail.status !== 'WP') return

      // 这里其实是禁用逻辑
      return {
        'internationalEnable': () => ifInternational === false,
        'mutualSaleEnable': () => isSelfAirline === true,
        'multipleTripEnable': () => isOneWay === true,
        'extraBookEnable': () => isOnlyTicket === true,
        'jjcEnable': () => isJJC === false,
        'useCouponEnable': () => isUseCoupon === false
      }
    }
  },
  components: {
    PayBox
  },
  filters: {
    payLimit (value) {
      value = parseInt(value)
      if (isNaN(value)) {
        return ''
      }

      if (value <= 0) {
        return '0分钟'
      }

      const duration = moment.duration(value)
      const m = duration.minutes()
      const s = duration.seconds()

      return `${m}分${s}秒`
    }
  }
}
</script>

<style lang="less">
.mod-order-pay {
  padding-top: 50px;

  .fetch-loading-container{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    width: 100%;
  }

  em {
    color: @primary-color;
    font-style: normal;
    font-weight: bold;
  }

  .tips {
    font-size: 14px;
    width: 650px;
    margin-top: 14px;
  }

  .pay-itinerary {
    margin-top: 25px;
  }

  .pay-itinerary-table {
    font-size: 14px;
    border: 1px solid #bfbfbf;
    width: 100%;

    ._b {
      color: #111;
      font-weight: bold;
    }

    ._r {
      color: @primary-color;
    }

    td {
      padding: 10px;
    }

    td:last-of-type {
      text-align: right;
    }
  }

  .pay-box-outer {
    padding-bottom: 200px;

    .pay-card-container {
      background: #fff;
      min-height: 244px;
    }

    .pay-card-container > .ant-tabs-card > .ant-tabs-content {
      border: 1px solid #ccc;
      margin-top: -17px;
      background: #f5f5f5;
    }
  }

  .pay-head {
    color: #808080;
    line-height: 40px;
    padding-bottom: 5px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;

    .l8-icon {
      color: @primary-color;
      margin-right: 10px;
    }

    .price {
      margin: 0 40px;
    }

    .activity {
      position: relative;
      top: 12px;
      display: inline-block;
      height: 44px;
      width: 355px;
      background: url("./image/discount_pay.png") no-repeat 0 0;
    }
  }

  .submit-error {
    padding: 60px 50px;
    text-align: center;
  }

  .pay-foot {
    text-align: right;
    margin-top: 60px;

    .btn {
      margin-left: 40px;
      width: 102px;
      height: 50px;
    }
  }

  .f-26 {
    font-size: 26px;
  }

  .f-18 {
    font-size: 18px;
  }

  .f-16 {
    font-size: 16px;
  }

  .f-left {
    float: left;
  }

  .m-t-50 {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 768px) {
  .mod-order-pay {
    padding: 10px;
    .head {
      line-height: normal;
      padding-bottom: 10px;
      .order-num {
        float: left;
      }

      .price {
        margin: 0 10px;
      }
    }

    .tips {
      width: 80%;
    }

    .f-26 {
      font-size: 20px;
    }
  }
}
</style>
